module.exports = __webpack_public_path__ + "59c69c5f9680d18fd059db345020704b.png";